import { Box } from '@mui/material';
import { styled } from '@mui/styles';
import { boxShadowCard } from 'utils/consts';

export const Container = styled(Box)((props) => {
  const styles = props.noBgWrapper ? {} : {
    borderRadius: 16,
    backgroundColor: 'white',
    boxShadow: boxShadowCard,
  };
  return ({
    ...styles,
    margin: '1rem 3rem 1rem 3.75rem',
  });
});
